module.exports = __webpack_public_path__ + "static/img/图片23.d62f9ec7.png";